// extracted by mini-css-extract-plugin
export default {"form":"styles_form__BxnVY","submit":"styles_submit__+dpOU","cancel":"styles_cancel__Rgq3X","resend":"styles_resend__KAbPE","resend-button":"styles_resend-button__Vi1bd"};